import { summarizePrescription as summarizePrescriptionApi } from "./assessment";

function getErrorMessage(err: unknown): string {
  if (
    typeof err === "object" &&
    err !== null &&
    "message" in err &&
    typeof (err as { message: unknown }).message === "string"
  ) {
    return (err as { message: string }).message;
  }

  if (err instanceof Error) {
    return err.message;
  }

  return "Failed to generate prescription summary";
}

export function formatSummaryError(err: unknown): string {
  const message = getErrorMessage(err);

  if (message === "Failed to fetch" || message.includes("NetworkError")) {
    return "Could not generate prescription summary. Check your internet connection and try again.";
  }

  if (message.includes("not available") || message.includes("not configured")) {
    return "Prescription summary is not available. A Super Admin must enable Okhati AI for this resource centre.";
  }

  if (message.includes("401") || message.includes("403") || message.includes("Unauthorized")) {
    return "Prescription summary is temporarily unavailable. Please contact support.";
  }

  return message;
}

export default async function summarizePrescription(transcript: string): Promise<string> {
  const trimmedTranscript = transcript.trim();

  if (!trimmedTranscript) {
    throw new Error("No prescription text to summarize");
  }

  try {
    return await summarizePrescriptionApi(trimmedTranscript);
  } catch (err) {
    throw new Error(formatSummaryError(err));
  }
}
